/**
 * Session keys owned by this application.
 *
 * IMPORTANT: MSAL stores its account, id_token and refresh_token in
 * localStorage (see msalConfig `cacheLocation`), shared across all tabs. A
 * blanket `.clear()` on either storage would destroy the MSAL cache and
 * force a full interactive re-authentication in every open tab. Always clear
 * these keys explicitly and let MSAL manage its own cache via
 * `logoutRedirect()`.
 */
export const APP_SESSION_KEYS = [
  "jwtToken",
  "loginType",
  "userName-storage",
  "errorInFetchingData-storage",
  "merchantList-storage",
  "reportList-storage",
  "report-storage",
];

/**
 * Removes all application state without touching the MSAL token cache.
 */
const clearAppSession = () => {
  APP_SESSION_KEYS.forEach((key) => {
    sessionStorage.removeItem(key);
    localStorage.removeItem(key);
  });
};

export default clearAppSession;

